module.exports = __webpack_public_path__ + "img/dagger.f130d19f.jpeg";